import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Badge, Button } from 'react-bootstrap';
import { blogs } from '../../data/blogs';
import './BlogDetail.css';

const BlogDetail = () => {
  const { id } = useParams();
  const blog = blogs.find(b => String(b.id) === String(id));

  if (!blog) {
    return (
      <Container className="py-5">
        <h2>Blog not found</h2>
        <Button as={Link} to="/blogs" variant="primary" className="mt-3">Back to Blogs</Button>
      </Container>
    );
  }

  return (
    <div className="blog-detail py-5">
      <Container>
        <div className="mb-3 d-flex align-items-center flex-wrap gap-2">
          <Badge bg="primary">{blog.category}</Badge>
          <small className="text-muted">{new Date(blog.date).toLocaleDateString('en-IN')} • {blog.readTime}</small>
        </div>
        <h1 className="display-5 fw-bold mb-3">{blog.title}</h1>
        <img src={blog.image} alt={blog.title} className="img-fluid rounded mb-4" />
        <div className="content lead">
          <p>{blog.content}</p>
        </div>
        <div className="mt-4">
          {blog.tags.map(tag => (
            <Badge key={tag} bg="light" text="dark" className="me-2">{tag}</Badge>
          ))}
        </div>
        <div className="mt-4">
          <Button as={Link} to="/blogs" variant="outline-secondary">Back to Blogs</Button>
        </div>
      </Container>
    </div>
  );
};

export default BlogDetail;
